import { Controller } from "@hotwired/stimulus"
import { Haptics } from "../lib/haptics"

// Auto-shows a Bootstrap modal when the controller connects
// Usage: data-controller="auto-modal" on a .modal element
export default class extends Controller {
  connect() {
    // Add haptic feedback listeners for modal events
    this.element.addEventListener('shown.bs.modal', () => Haptics.medium())
    this.element.addEventListener('hidden.bs.modal', () => Haptics.light())

    // Small delay to ensure DOM is ready
    setTimeout(() => {
      this.modalInstance = new bootstrap.Modal(this.element)
      this.modalInstance.show()
    }, 100)
  }

  disconnect() {
    if (this.modalInstance) {
      this.modalInstance.hide()
      this.modalInstance.dispose()
      this.modalInstance = null
    }
  }
}
